var exports = {
  "qS": "ActivityPresenceBadge.module__badge___OE8wb1",
  "Kk": "ActivityPresenceBadge.module__icon___OE8wb1",
  "Pf": "ActivityPresenceBadge.module__label___OE8wb1",
};

module.exports = exports;
